export enum StatusExecucao {

  PENDENTE = 'PENDENTE',
  INICIADO = 'INICIADO',
  FINALIZADO_COM_SUCESSO = 'FINALIZADO_COM_SUCESSO',
  FINALIZADO_COM_ERRO = 'FINALIZADO_COM_ERRO'

}
